import React, { useState, useEffect } from 'react'
import ReactQuill from 'react-quill';
import Utils from "Utils";
import 'react-quill/dist/quill.snow.css';

export function RichEditor({
    value,
    fieldName,
    setFieldValue,
    touched = {},
    errors = {},
    isRequired = false,
    label = null,
    options = {} }) {
    const [firstRender, setFirstRender] = useState(true)

    useEffect(() => {
        setFirstRender(false)
    }, [])

    const changeHandler = (e) => {
        setFieldValue(fieldName, e)
    }
    return (
        <div className="custom-field flex flex-column">
            <div className={`label ${isRequired && 'required'}`}>{label || Utils.convertSnakeCaseToSpace(fieldName)}</div>
            {!firstRender && <ReactQuill theme="snow"
                value={value}
                onChange={changeHandler}
                {...options} />}
            <div className="error">
                {errors[fieldName] && touched[fieldName] && errors[fieldName]}
            </div>
        </div>

    )
}
